
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/limit-order",
      function () {
        return require("private-next-pages/limit-order.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/limit-order"])
      });
    }
  